
export default function Loader(){
    return(
        <>
        <img src="https://i.pinimg.com/originals/75/85/41/7585415efe7f6734445a63e377592375.gif" />
        </>
    )
}